import { render, staticRenderFns } from "./contract-details.vue?vue&type=template&id=05c78d9f&scoped=true&"
import script from "./contract-details.vue?vue&type=script&lang=js&"
export * from "./contract-details.vue?vue&type=script&lang=js&"
import style0 from "./contract-details.vue?vue&type=style&index=0&id=05c78d9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c78d9f",
  null
  
)

component.options.__file = "contract-details.vue"
export default component.exports